/* ============================================================
   VELLYN — front-end interactions (no dependencies)
   - Offer selector (home teaser + PDP variant driver)
   - PDP quantity stepper + sticky add-to-cart
   - Cart free-shipping progress bar (drawer)
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents, format) {
    var v = (cents / 100);
    var s = v.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (format || '{{amount}} lei').replace('{{amount}}', s).replace('{{ amount }}', s);
  };

  /* ---------------- Offer selector ---------------- */
  function initOffer(root) {
    var opts = root.querySelectorAll('.vl-opt');
    var priceEls = document.querySelectorAll('[data-vl-price-out="' + root.dataset.vlOffer + '"]');
    var ctaEls = document.querySelectorAll('[data-vl-cta-out="' + root.dataset.vlOffer + '"]');
    var variantInput = document.querySelector('[data-vl-variant-input="' + root.dataset.vlOffer + '"]');

    function select(opt) {
      opts.forEach(function (o) { o.setAttribute('aria-pressed', String(o === opt)); });
      var price = opt.getAttribute('data-price');
      var ctaLabel = opt.getAttribute('data-cta') || 'Adaugă în coș';
      var variantId = opt.getAttribute('data-variant-id');
      priceEls.forEach(function (el) { if (price) el.textContent = price; });
      ctaEls.forEach(function (el) { el.textContent = ctaLabel; });
      if (variantInput && variantId) variantInput.value = variantId;
      root.dispatchEvent(new CustomEvent('vl:offerchange', { bubbles: true, detail: { opt: opt, variantId: variantId, price: price } }));
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () { select(opt); });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(opt); }
      });
    });

    var preset = root.querySelector('.vl-opt[aria-pressed="true"]') || opts[0];
    if (preset) select(preset);
  }

  /* ---------------- PDP quantity + sticky ATC ---------------- */
  function initBuybox(box) {
    var stepper = box.querySelector('.vl-stepper');
    var input = box.querySelector('.vl-stepper input');
    if (stepper && input) {
      stepper.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-step]');
        if (!b) return;
        var next = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10);
        input.value = Math.min(parseInt(input.max, 10) || 9, Math.max(1, next));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    var sticky = document.querySelector('.vl-sticky-atc');
    var mainCta = box.querySelector('[data-vl-main-cta]');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      sticky.style.transition = 'opacity .2s, transform .2s';
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var hidden = en.isIntersecting;
          sticky.style.opacity = hidden ? '0' : '1';
          sticky.style.transform = hidden ? 'translateY(100%)' : 'translateY(0)';
          sticky.style.pointerEvents = hidden ? 'none' : 'auto';
        });
      }, { rootMargin: '0px 0px -40% 0px' });
      io.observe(mainCta);
    }

    // keep sticky button label + price in sync with the offer selector
    var offerRoot = document.querySelector('.vl-offer[data-vl-offer]');
    if (offerRoot && sticky) {
      offerRoot.addEventListener('vl:offerchange', function (e) {
        var priceOut = sticky.querySelector('[data-vl-sticky-price]');
        if (priceOut && e.detail.price) priceOut.textContent = e.detail.price;
      });
    }
  }

  /* ---------------- PDP gallery ---------------- */
  function initGallery(gallery) {
    var mainImg = gallery.querySelector('[data-vl-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-vl-gallery-thumbs] button');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (full) { mainImg.src = full; mainImg.removeAttribute('srcset'); }
        thumbs.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      });
    });
  }

  /* ---------------- Cart free-shipping progress ---------------- */
  function renderShip(el, totalCents) {
    var threshold = parseInt(el.dataset.vlThreshold, 10) || 0;
    var fmt = el.dataset.vlMoneyFormat || '{{amount}} lei';
    var bar = el.querySelector('[data-vl-ship-bar]');
    var msg = el.querySelector('[data-vl-ship-msg]');
    if (threshold <= 0) return;
    var pct = Math.max(0, Math.min(100, Math.round((totalCents / threshold) * 100)));
    if (bar) bar.style.width = pct + '%';
    var gap = threshold - totalCents;
    if (msg) {
      msg.innerHTML = gap > 0
        ? 'Îți mai lipsesc <b>' + money(gap, fmt) + '</b> până la livrarea gratuită'
        : 'Ai livrare gratuită. Bravo!';
    }
  }

  function initShip(el) {
    var initial = parseInt(el.dataset.vlCartTotal, 10);
    if (!isNaN(initial)) renderShip(el, initial);
    document.addEventListener('cart:updated', function (e) {
      var t = e && e.detail && (e.detail.cart ? e.detail.cart.total_price : e.detail.total_price);
      if (typeof t === 'number') { renderShip(el, t); return; }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { renderShip(el, c.total_price); })
        .catch(function () {});
    });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    document.querySelectorAll('.vl-offer[data-vl-offer]').forEach(initOffer);
    document.querySelectorAll('.vl-buybox').forEach(initBuybox);
    document.querySelectorAll('.vl-gallery').forEach(initGallery);
    document.querySelectorAll('[data-vl-ship]').forEach(initShip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Horizon re-renders sections in the editor
  document.addEventListener('shopify:section:load', boot);
})();
